import { render, staticRenderFns } from "./index.vue?vue&type=template&id=63567baf&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63567baf')) {
      api.createRecord('63567baf', component.options)
    } else {
      api.reload('63567baf', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=63567baf&", function () {
      api.rerender('63567baf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/alf/homeComponents/fifth/index.vue"
export default component.exports